module.exports = __webpack_public_path__ + "static/img/back-3-1.eb79b0ec.png";